<template>
    <div>

        <div>
            
            <div class="myStickyBar">

                <div class="w-full border border-gray-200" :key="pitchSlot.length">

                    <pitches-panel :panelObject="panelObject" :allSlots="pitchSlot" ref="pitchPanel" :toastIt="toastIt"
                    :fixedDayDate="fixedDayDate" :openMapModal="openMapModal" :countiesOptions="countiesOptions"
                    :pitchTypesOptions="pitchTypesOptions"
                    :setDate="setDateFromPanel" :refreshMap="refreshMap"/>
                </div>

                <div class="myDateBar">

                    <my-date-bar :myDates="myDates" :setDate="setDateFromBar" ref="sessionsBar" :useWithPanel="true"/>
                </div>

                <div v-if="!isFromBusinessBrowse">

                    <my-tabs :itemIsSelected="tabIsSelected"/>
                </div>
            </div>

            <div class="mySessionsMainDiv">

                <div class="overflow-y-scroll w-full h-full allText">

                    <transition  name="right-in">

                        <div v-if="showMap" class="myMapDiv mb-40" >
                        
                        <pitch-map-modal :showModal="showMap" :modalSlots="panelObject.categorizedSlots" :highlightedLocation="highlightedLcoation"
                        :myReload="myReload" :isCard="true" :displayModal="displayModal"
                        :dayDate="panelObject.dayDate" :searchStartTime="searchStartTime" :searchEndTime="searchEndTime" 
                        :showOnlyTheOnePitch="showOnlyTheOnePitch" :refreshedMap="refreshedMap"
                        :changeShowModal="changeShowMapModal" :showPitchPage="showPitchPage" :onePitchSlot="selectedOnePitch"
                        :showDescription="showDescription" :disableButton="disableButton" :openOnePitchMapModal="openOnePitchMapModal"/>
                        </div>
                    </transition>

                    <transition name="bottom-up">

                        <div v-if="displayPitchPage"
                        class="modalDiv myFullCenter h-full">

                                <div class="subModalDiv" v-click-outside="closePitchPage" :key="panelObject.dayDate">

                                    <pitch-page :myPitch="myPitch" 
                                    :lastDayDate="panelObject.dayDate" :closePitchPage="closePitchPage"/>
                                </div>
                        </div>
                    </transition>
                </div>

                <div v-show="!showMap">

                    <div v-if="panelObject.categorizedSlots.length > 0"
                    class="myColCenter lg:p-5 myRounded h-full w-full mt-10">

                        <div class="mySessionsDivider" :key="panelObject.dayDate">
                            
                            <div class="myCardDiv" ref="slotRef" v-for="(oneSlot, index) in panelObject.categorizedSlots" :key="oneSlot.id">

                                <pitch-card :key="panelObject.dayDate" :disablePage="disablePage"
                                :email="email" :myReload="myReload" :isCard="true" :displayModal="displayModal"
                                :mySlot="oneSlot" :index="index" :dayDate="panelObject.dayDate" :showPitchPage="showPitchPage" 
                                :showDescription="showDescription" :searchStartTime="searchStartTime" :searchEndTime="searchEndTime"
                                :disableButton="disableButton" 
                                :openOnePitchMapModal="openOnePitchMapModal"/>
                            </div>
                        </div>
                    </div>

                    <div v-else class="h-40">
                            
                        <div class="myFullCenter mt-40">
                            
                            <p class="mt-2 lg:mt-5 p-5 bg-blue-300 rounded-full border-blue-800 border-4">
                                <strong>{{$t('sessions.noSessionsAvailable')}}</strong></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import Vue from 'vue';

import myTabs from '../../components-v2/controls/MySessionsTabs'

import myDateBar from '../../components-v2/Bars/MyDatesBar'

import vueMultiSelect from 'vue-multi-select'; 
import 'vue-multi-select/dist/lib/vue-multi-select.css';

import 'vue2-timepicker/dist/VueTimepicker.css'

import { RingLoader } from 'vue-spinners-css';

import myQueries from '../../hasura/myQueries';

// import twoMyQueries from '../hasura/twoMyQueries';

import componentsHelpers from '../../classes/componentHelpers';

// // import axios from '@/classes/myAxios'
import axios from '@/classes/myAxios'


import moment from 'moment';

import pitchCard from './PitchCard';

// import pitchCard from '../components-two/PitchInfoOrCard';

import pitchesPanel from './PitchesPanel';

import PitchMapModal from './PitchMapsModal';

import pitchPage from './PitchSlotPage';

import myTwoQueries from '../../hasura/myTwoQueries';

import componentsMethods from '../../classes/componentsMethods';

export default {

    created(){

        this.todayDate = this.dayDate;        
    },

     async mounted(){

        await this.loadData();

        this.panelObject.categorizedSlots = this.pitchSlot;

        this.allLoaded = true;

        // localStorage.setItem('clientLayout3', 'bookingPitches');
        if(!this.isFromBusinessBrowse){

          this.$layoutType = 2; 
        }

        this.setDates();


        const parameters = this.$route.query;

        if(typeof parameters.selected === 'undefined'){
        }
        else{

            while(this.pitchSlot.length < 1){
            
            }
        }

        if(localStorage.hasOwnProperty("pitchesMinimizeAll")){

            const savedValue = Number(localStorage.getItem('pitchesMinimizeAll'));

            // console.log(`savedValue: ${savedValue}`);

            this.minimizeAll = savedValue == 1 ? true: false;
        }

        const myFilter = item => Number(item.id) == Number(parameters.selected);
        
        //   this.businessOptionsProxy = this.businessOptions.filter(myFilter);
    },

    props:{

      myBusinessId: 0,

      isFromBusinessBrowse: false,

      pitchSlot:{

        type: Array
      }
    },

    components:{


        RingLoader,
        pitchCard,
        PitchMapModal,
        myTabs,
        pitchesPanel,
        myDateBar,
        vueMultiSelect,
        pitchPage
    },

    computed: {

    isToday(){

        if(this.dayDate == moment(new Date()).format(moment.HTML5_FMT.DATE))
        {
            return true;
        }

    return false;
        }
    },

    methods:{


        async loadData(){

            try{

                const countryName = 'Kuwait';

                this.loading = true;

                let result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getLocationAndPitchType',
                    data: {
                    
                        countryName: countryName,
                    }
                });

            // console.log(`result.data.length: ${JSON.stringify(result.data.two_pitch_slot.length)}`);

                this.category = result.data.category;

                this.county = result.data.location_country_county;

                this.countiesOptions = this.county.filter(item=>item);

                this.pitchTypesOptions = result.data.two_pitch_type;

                // console.log(`this.countiesOptions: ${JSON.stringify(this.countiesOptions)}`);
                this.loading = false;

            }catch(error){

                componentsHelpers.sendError(this.$apollo, this.userId,'PublicInfo', 'publicPitches', 'loadData', error);

                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                this.loading = false;
            }
        },


        refreshMap(){

            this.refreshedMap++;
        },      

        tabIsSelected(tab){

            if(tab == 2){

                this.showMap = true;;
            }else{

                this.showMap = false;
            }
        },

        setDates(){

            this.myDates = componentsMethods.getDates();
        },

        setDateFromBar(date){


            const tempDate = moment(date).format(moment.HTML5_FMT.DATE);
            this.panelObject.dayDate = tempDate;

            this.$refs.pitchPanel.setNewDate(tempDate)
            // this.$refs.pithcPanel.setSlots();
        },

        setDateFromPanel(date, isNext){

            this.panelObject.dayDate = moment(date).format(moment.HTML5_FMT.DATE);
            this.$refs.sessionsBar.changeDate(isNext);
        },

        showDescription(mySlot){

            this.showPitchPage(mySlot.two_pitch);

          // console.log(`showDescription`)
        },

        isIos(){

            return componentsHelpers.isIos();
        },

        sendAddAnEvent(newEvent){
  

            if(typeof window.webkit != 'undefined'){
                
                window.webkit.messageHandlers.addAnEvent.postMessage(JSON.stringify(newEvent));
            }else{

            }                  
        },

      showPitchPage(myPitch){

        // console.log(`inside showPitchPage`);
        this.myPitch = myPitch;

        this.displayPitchPage = true;

      },

      closePitchPage(){

          this.myPitch = null;

          this.displayPitchPage = false;
      },

      toastIt(msg, option, type = 1){
      
          // console.log(`option ${option}`);
          let subOptions;

                  
          if(type == 1){
              if(option == 1)
              {
                  subOptions =  { theme: "bubble", position: "bottom-center", duration : 5000};
              }
              else if(option == 2){

                  // console.log('option 2');

                  subOptions =  {  theme: "outline", position: "bottom-center", duration : 5000};
              }
              else{
                  
                  // console.log('option 3');

                  // subOptions =  { type: "error",	 theme: "toasted-primary", position: "bottom-center", duration : 5000};
                  subOptions =  { theme: "toasted-primary", position: "bottom-center", duration : 5000};
              }

              this.$toasted.clear();
              this.$toasted.error(msg, subOptions);
          }
          else{
              
              subOptions =  { iconPack: 'fontawesome',fitToScreen: true, theme: "bubble", position: "bottom-center", duration : 5000};

              this.$toasted.clear();
              this.$toasted.error(msg, subOptions);
          }
      },

      openMapModal(){

        this.showMap = true;
      },

      openOnePitchMapModal(pitchSlot){

            this.showOnlyTheOnePitch = true;
            this.selectedOnePitch = pitchSlot;
            this.showMap = true;
        },
        
      async sleep(ms){
      
      this.count = this.count + 1;
      return await new Promise(resolve => setTimeout(resolve, ms));
      },


      displayModal(modalImages){

        //   console.log(`modalImages: ${JSON.stringify(modalImages)}`);

          if(modalImages.length > 0){  

              this.modalImages = modalImages;

              this.changeShowModal(true);
          }
      },

      changeShowModal(val){

          if(val == false){

              this.modalImages = [];
          }

          this.showModal = val;
      },

      changeShowMapModal(val){

          this.showMap = val;
        this.showOnlyTheOnePitch = val;
        this.selectedOnePitch = null;

      },


      dayOfWeekAsString(dayIndex) {
          
          return [this.$t('slot.sunday'), this.$t('slot.monday'), this.$t('slot.tuesday'),this.$t('slot.wednesday'),this.$t('slot.thursday'),this.$t('slot.friday'),this.$t('slot.saturday')][dayIndex];
      },

      myReload(){


        location.reload();
      },


      changeCardView(isMaximize, index){
          
          Vue.set(this.cardsViews, index, !isMaximize);
      },

      setHighlightedLocation(index){

          this.highlightedLcoation = this.categorizedSlots[index].class.location;
      },

    },

    data: function(){

      return {

        panelObject:{

            minimizeAll: false,
            onlyOnline: false,
            categorizedSlots: new Array(),
            dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
        },

        myDates: [],

        weekDays:[
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday'
        ],
        
        loading: false,
        disableButton: false,
        disablePage: false,
        // onlyOnline: true,
        highlightedLcoation: null,
        locations: [],
        showModal: false,
        showMap: false,
        modalImages:[],
        minimizeAll: true,
        tokenId: '',
        userId:JSON.stringify(this.$userId) != "{}" ? this.$userId: 0,
        email:'',
        type:[],
        county:[],
        categorizedSlots:[],
        timedCategorizedSlots:[],
        weekDayCategorizedSlots:[],
        bookings: [],
        startTimeAfter: '',
        startTimeBefore: '',
        savedStartTimeAfter: '',
        savedStartTimeBefore: '',
        countiesOptions: [],
        pitchTypesOptions: [],

        timeBeforeColor: '',
        timeAfterColor: '',
        cardsViews:[],
        tokenError: '',
        userInfoError:'',
        locationError:'',
        countiesError:'',
        slotError: '',
        typeError: '',
        bookingsError: '',
        groupsError: '',
        createNew: false,
        allLoaded: false,
        editMode: [],
        editableClass: null,
        editableIndex: -1,
        dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
        fixedDayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
        todayDate: '',
        storedKey: localStorage.getItem('for_pnadi'),
        selectedTitle:'',
        selectedDescription: '',
        popoverShow:false,
        bookingsSubscribeError: '',
        slotSubscribeError: '',
        subscribeUserError: '',
        bookingsCountsSubscribeError: '',
        displayPitchPage: false,
        myClass: null,
        searchStartTime: '08:00',
        searchEndTime: '23:00',
        clearFirstClicked: null,
        clearSecondClicked: null,
        clickedTimes: [],
        bookingStartTime: '',
        bookingEndTime: '',
        clickedSlotId: 0,

        showOnlyTheOnePitch: false,
        selectedOnePitch: null,

        refreshedMap: 0,

      }
    },

    watch: {
        
        dayDate: function(val, oldVal) {

            // this.categorizedSlots.splice(0, this.categorizedSlots.length)
            // console.log(`pop finished`);

            this.changeDayDate(val);
        },

       '$userId'(newValue){

         this.userId = newValue;
        }
    }
}
</script>

<style>


.bottom-up-enter-active{

    animation: slide-bottom-up 0.5s ease-in;
}

.bottom-up-leave-active{
    
    animation: slide-top-down 0.5s ease-in;
}

@keyframes slide-bottom-up{
        from  { transform: translateY(100%);}
        to { transform: translateY(0);} 
}
@keyframes slide-top-down{
    from  { transform: translateY(0%);}
    to { transform: translateY(100%);} 
}

.right-in-enter-active{

    animation: slide-right-in 0.5s ease-in;
}

.right-in-leave-active{
    
    animation: slide-right-out 0.5s ease-in;
}

@keyframes slide-right-in{
        from  { transform: translateX(100%);}
        to { transform: translateX(0);} 
}
@keyframes slide-right-out{
    from  { transform: translateX(0%);}
    to { transform: translateX(100%);} 
}


</style>